export default "__VITE_ASSET__C57r$JXy__"